import { Grid, withStyles } from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import { withSnackbar } from 'notistack';
import React from 'react';
import {
  getShipperErrorInfo,
  getPickupDateTimeErrorInfo,
  getTerminalFieldError,
  getSearchFieldError,
  getShipperPickupWindow,
  getLatestReadyCloseTime,
  getDefaultPickupDateTimeInfo
} from './ShipperInfo/utils';
import {
  getShipmentErrorInfo,
  checkAtLeastOneShipmentInvalid,
  getDefaultShipment
} from './ShipmentInfo/utils';
import { getEditReasonErrorInfo } from './EditReasonInfo/utils';
import { withUserProfile } from '../../../../../../userProfile/userProfileContext';
import { compose } from 'recompose';
import { postData } from '../../../../../../api/componentAPIs';
import appConstants from '../../../../../../appConstants';
import { AppLoading } from '../../../../../../loaders/loaders';
import Events from '../../../../../../utilities/EventEmitter';
import PickupTypeToggles from './components/PickupTypeToggles';
import BillingForm from './Billing';
import PickupRequestorInfo from './ReservationRequestorInfo';
import { getRequestorErrorInfo } from './ReservationRequestorInfo/utils';
import PanelAction from './components/Action';
import ErrorContainer from './components/Error';
import WithModal from './components/WithModal';
import { PICKUP_MANAGEMENT_CONFIG, getPickupDateTime } from './config';
import {
  PICKUP_MANAGEMENT_MODES,
  WARNING_DETAILS,
  ORDERERD_FIELD_LIST,
  FORM_VALIDATION_MSG
} from './constants';
import ShipmentInfoForm from './ShipmentInfo';
import ShipperInfoForm from './ShipperInfo';
import PickupInfo from './ShipperInfo/PickupInfo';
import {
  getConfirmationButtonLabel,
  getDefaultPickupManagementErrorInfo,
  getDefaultPickupManagementInfo,
  getSavePickupMessage,
  checkIsDateTimeUpdated,
  resolveSelectedTerminal,
  isReadOnlyPickupViewMode,
  isMergePickupMode,
  getFormattedShippers,
  getFormattedTerminals,
  fetchTerminalAndRestrictionsData,
  getCombinedSpecialInstructions,
  getFirstSelectedAssignedDriverPickup,
  getShipperByPickupId,
  validateToggle,
  isCreateOrEditPickupMode,
  isEmbargoPickupMode,
  isBulkEditPickupMode,
  isBulkVoidPickupMode,
  isBulkPickupMode,
  getBulkEditInitialData,
  mergeBulkGroupPickupTypeToggles,
  getBulkPickupNumbers,
  getBulkGroupId,
  getBulkPickupRowForPickupInfo,
  shouldShowRequestorInPickupManagement,
  isPickupManagementBillingMode
} from './utils';
import { getDuplicatePickupCheckerParams } from './DuplicatePickupChecker/utils';
import EditReasonForm from './EditReasonInfo';
import VoidPickup from './VoidPickupInfo';
import UnvoidPickup from './UnvoidPickupInfo';
import DuplicatePickupChecker from './DuplicatePickupChecker';
import { getDefaultVoidPickData, getErrorInfo } from './VoidPickupInfo/utils';
import Warning from './components/Warning';
import SelectShipperForm from './MergePickupShipperDetails';
import DriverDetails from './MergePickupShipperDetails/DriverDetails';
import { isEqual, isObject } from 'lodash/lang';
import { withFeatureFlags } from '../../../../../../userProfile/featureFlagsContext';
import { withAppConfig } from '../../../../../../appConfigContext';
import { getDefaultUnvoidPickData } from './UnvoidPickupInfo/utils';
import { DRIVER_EVENTS } from '../../constants';
import { RMAXLogger } from '@RMAXLogger';
import cloneDeep from 'lodash/cloneDeep';
import NoFreightInfo from './NoFreightInfo';
import SelectedPickupsInfo from './components/SelectedPickupsInfo';
import { APP_EVENT_NAMES } from '../../../../../../signalR/constants';
const { DISPATCH } = APP_EVENT_NAMES;
import { getDefaultNoFreightInfo, getNoFreightErrorInfo } from './NoFreightInfo/utils';
import { convertDateTimeToTimeString } from '@dataGrid/gridUtilities';
import { getNoFreightCodeOptionLabel } from '../../../utils/utils';
import { isNotAssignedPickup } from '../../filterUtils';
import { sortShipmentsBySeq } from '../utils';
import RequiresLG from './components/RequiresLG';
import { sanitizeObject } from '../../../../../../utilities/dataUtils';
import {
  EmbargoPickupManagementBanners,
  EMPTY_EMBARGO_CONFIG,
  EMBARGO_MODES,
  fetchPickupRestrictionsWithEmbargo,
  isPickupRestrictionsCacheValid,
  normalizePickupRestrictionsData,
  parsePickupRestrictionsResponse,
  resolvePickupSaveFailure,
  validateEmbargo,
  buildEmbargoFormContext,
  isEmbargoBlockingConfirm
} from './Embargo';
const styles = (theme) => ({
  dialogMainContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%'
  },
  contentContainer: {
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingTop: 16,
    height: '100%'
  },
  leftPanelContainer: {
    marginTop: 8
  },
  rightPanelContainer: {
    paddingRight: 24
  },
  actionContainer: {
    display: 'flex',
    flexDirection: 'row',
    padding: '8px 24px 24px 24px',
    flex: 1,
    justifyContent: 'flex-end'
  },
  toggleErrorMessage: {
    color: theme.errorBorderColor,
    fontSize: theme.dispatchCardTextFontSize,
    marginLeft: 4,
    marginBottom: 8
  },
  detailsColumnWise: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center'
  }
});

@inject('DispatchStore')
@observer
class PickupManagementForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isDateTimeUpdated: false,
      terminals: [],
      selectedTerminal: null,
      selectedTerminalError: null,
      selectedTerminalOffset: null,
      searchFieldError: null,
      pickupInfo: null,
      pickupErrorInfo: getDefaultPickupManagementErrorInfo(),
      voidPickup: getDefaultVoidPickData(),
      unvoidPickup: getDefaultUnvoidPickData(),
      noFreightPickup: getDefaultNoFreightInfo(),
      error: null,
      hasWarning: false,
      overrideWarning: false,
      isShipperSearched: false,
      selectedShipper: '',
      shipperList: [],
      selectedDriver: null,
      driverRoute: null,
      pickupData: null,
      shipmentGridError: appConstants.GRID_STATUS.SUCCESS,
      isConfirmButtonDisabled: false,
      isExhibitPickupInMergeMode: this.isExhibitPickupInMergeMode(),
      embargoConfig: EMPTY_EMBARGO_CONFIG,
      embargoShipmentViolations: [],
      embargoShipmentWarnings: [],
      embargoBackendSaveError: null
    };
    this.pickupRestrictionsData = [];
    this.pickupRestrictedTerminals = [];
    this.isMiscellaneousAccountCode = false;
    this.warning = null;
    this.timer = null;
    this.embargoRulesRequestId = 0;
     this.enablePickupEdit = this.props.featureFlags.isFeatureEnabled(
      appConstants.features.EnablePickupEdit
    );
    this.enablePickupGrouping = this.props.featureFlags.isFeatureEnabled(
      appConstants.features.EnablePickupGrouping
    );
    this.enableRequestorInfo = Boolean(this.props.configJSON?.enableRequestorDetailsForPickups);
    this.enableNoFreightCode =
      this.props.configJSON?.noFreightConfigParsed?.enableNoFreightCode;
    this.enableReturnExceptionReasonLabels = Boolean(
      this.props.configJSON?.enableReturnExceptionReasonLabels
    );
    this.enforceNoFreightReasonCodeIfExists =
      this.props.configJSON?.noFreightConfigParsed?.enforceNoFreightReasonCodeIfExists;
    this.noFreightCodes = this.getNoFreightCodes();
    this.showNoFreightCodeDropdown = this.enableNoFreightCode && this.noFreightCodes?.length > 0;
    this.shouldEnforceNoFreightReasonCode =
      this.showNoFreightCodeDropdown && this.enforceNoFreightReasonCodeIfExists;
    this.isUnmounted = false;
    this.isReadOnlyPickupMergeMode =
      this.enablePickupGrouping && isMergePickupMode(this.props.mode);
    this.shipmentInfo = [];
    this.originalBulkShipments = [];
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !isReadOnlyPickupViewMode(this.props.mode) &&
      (prevState.selectedTerminal !== this.state.selectedTerminal ||
        prevState.pickupInfo?.shipperInfo !== this.state.pickupInfo?.shipperInfo ||
        prevState.pickupInfo?.shipmentInfo !== this.state.pickupInfo?.shipmentInfo)
    ) {
      this.pickupRestrictionsValidation();
      this.runEmbargoValidation();
    }
    const prevEmbargoPickupDate = this.getEmbargoPickupDateFromState(prevState);
    const embargoPickupDate = this.getEmbargoPickupDate();
    if (
      isEmbargoPickupMode(this.props.mode) &&
      prevEmbargoPickupDate !== embargoPickupDate
    ) {
      this.loadPickupRestrictionsAndEmbargo(
        this.props.userData.userProfile.terminal.code,
        this.getEmbargoPickupDate()
      );
    }
    if (
      isMergePickupMode(this.props.mode) &&
      this.state.selectedShipper &&
      !isEqual(this.props.pickupData, prevProps.pickupData)
    ) {
      this.refreshShipperList(this.getFormattedPickupData([]));
    } else if (
      this.props.mode === PICKUP_MANAGEMENT_MODES.NO_FREIGHT_PICKUP &&
      !isEqual(this.props.pickupData, prevProps.pickupData)
    ) {
      this.setState({
        isConfirmButtonDisabled: !isNotAssignedPickup({
          pickup: this.props.pickupData,
          terminalOffset: this.state.selectedTerminalOffset
        })
      });
    }
  }

  refreshShipperList = (pickupData) => {
    const { selectedPossibleMergePickupId } = this.props;
    const selectedShipper = JSON.parse(this.state.selectedShipper);
    const isNoLongerDuplicatePickup = pickupData.find(
      (pickup) => pickup.pickupId?.toLowerCase() !== selectedShipper.pickupId.toLowerCase()
    );
    const shipperList = getFormattedShippers(pickupData, selectedPossibleMergePickupId);
    if (isNoLongerDuplicatePickup) {
      const firstAssignPickupSelected = getFirstSelectedAssignedDriverPickup(pickupData);
      const selectedPickupData = this.getMergePickupInitialData(
        firstAssignPickupSelected ?? pickupData[0],
        pickupData
      );
      this.setState({
        pickupInfo: getDefaultPickupManagementInfo(
          selectedPickupData,
          this.state.selectedTerminalOffset
        ),
        shipperList,
        selectedShipper: getShipperByPickupId(shipperList, selectedPickupData.pickupId),
        selectedDriver: firstAssignPickupSelected?.driverId,
        pickupData: this.getFormattedPickupData(this.state.pickupData)
      });
      this.updateIsMiscShipper(
        selectedPickupData?.shipperAccountNumber,
        selectedPickupData?.isMiscellaneousShipper
      );
    } else {
      this.setState({ shipperList });
    }
    this.setShipmentInfo();
  };

  isExhibitPickupInMergeMode = () => {
    if (!isMergePickupMode(this.props.mode)) {
      return false;
    }
    return this.props.pickupData.some((pickup) => pickup.isExhibitPickup);
  };

  getShipmentByPickupId = (pickupId, shipmentData) => {
    if (shipmentData?.length === 0) {
      return [];
    }
    const pickup = shipmentData.find(
      (pickup) => pickup.pickupId.toUpperCase() === pickupId.toUpperCase()
    );
    return pickup ? pickup.shipments : [];
  };

  getFormattedPickupData = (responseData) => {
    if (!this.props.pickupData) {
      return this.props.pickupData;
    }
    if (isMergePickupMode(this.props.mode) || isBulkPickupMode(this.props.mode)) {
      return this.props.pickupData.map((pickup) => ({
        ...pickup,
        shipments: this.getShipmentByPickupId(pickup.pickupId, responseData)
      }));
    } else {
      return {
        ...this.props.pickupData,
        shipments: this.getShipmentByPickupId(this.props.pickupData.pickupId, responseData)
      };
    }
  };

  getPickupShipments = (pickupId) => {
    this.setState({ shipmentGridError: appConstants.GRID_STATUS.LOADING });
    return postData('GetPickupShipments', {
      terminalCode: this.props.userData.userProfile.terminal.code,
      pickupIds: pickupId
    }).then(
      (response) => {
        if (this.isUnmounted) {
          return;
        }
        if (response && response.status === 200) {
          const pickupData = this.getFormattedPickupData(response.data);
          this.shipmentInfo = [];
          if (isMergePickupMode(this.props.mode) || isBulkPickupMode(this.props.mode)) {
            let shipmentData = pickupData.flatMap((pickup) =>
              (pickup.shipments || []).map((shipment) => ({
                ...shipment,
                pickupNumber: shipment.pickupNumber ?? pickup.pickupNumber
              }))
            );
            shipmentData = sortShipmentsBySeq(shipmentData);
            this.shipmentInfo = shipmentData.map((shipment) => getDefaultShipment(shipment)) || [];

            if (isBulkEditPickupMode(this.props.mode)) {
              this.originalBulkShipments = cloneDeep(this.shipmentInfo);
            }
          } else {
            let shipmentData = sortShipmentsBySeq(pickupData.shipments);
            this.shipmentInfo = shipmentData.map((shipment) => getDefaultShipment(shipment)) || [];
          }
          this.setState(
            (prevState) => ({
              pickupInfo: {
                ...prevState.pickupInfo,
                shipmentInfo: cloneDeep(this.shipmentInfo)
              },
              pickupData,
              shipmentGridError: appConstants.GRID_STATUS.SUCCESS
            }),
            () => {
              this.runEmbargoValidation();
            }
          );
        } else {
          this.handleGetPickupShipmentsFailure();
        }
      },
      () => {
        if (this.isUnmounted) {
          return;
        }
        this.handleGetPickupShipmentsFailure();
      }
    );
  };

  handleGetPickupShipmentsFailure = () => {
    this.shipmentInfo = [];
    const pickupData = this.getFormattedPickupData([]);
    this.setState({ pickupData, shipmentGridError: appConstants.GRID_STATUS.ERROR });
  };

  setShipmentInfo = () => {
    if (isBulkEditPickupMode(this.props.mode)) {
      const pickups = Array.isArray(this.props.pickupData) ? this.props.pickupData : [];
      if (pickups.length > 0) {
        this.getPickupShipments(pickups.map((pickup) => pickup.pickupId));
      }
      return;
    }
    if (isMergePickupMode(this.props.mode) || isBulkVoidPickupMode(this.props.mode)) {
      const pickups = Array.isArray(this.props.pickupData) ? this.props.pickupData : [];
      if (pickups.some((pickup) => pickup.bills > 0)) {
        this.getPickupShipments(pickups.map((pickup) => pickup.pickupId));
      }
    } else if (this.props.pickupData?.bills) {
      this.getPickupShipments([this.props.pickupData.pickupId]);
    }
  };

  resolveInitialSelectedPickupData = (pickupData) => {
    const { mode } = this.props;
    if (isMergePickupMode(mode)) {
      const firstAssignPickupSelected = getFirstSelectedAssignedDriverPickup(pickupData);
      return this.getMergePickupInitialData(
        firstAssignPickupSelected ?? pickupData[0],
        pickupData
      );
    }
    if (isBulkEditPickupMode(mode)) {
      const firstAssignPickupSelected = getFirstSelectedAssignedDriverPickup(pickupData);
      const primaryOrFirstPickup = getBulkPickupRowForPickupInfo(pickupData);
      return mergeBulkGroupPickupTypeToggles(
        pickupData,
        this.getMergePickupInitialData(
          firstAssignPickupSelected ?? primaryOrFirstPickup,
          pickupData
        )
      );
    }
    return pickupData;
  };

  initializeAllData = (pickupData) => {
    const { mode, userData, DispatchStore, selectedPossibleMergePickupId } = this.props;
    if (isReadOnlyPickupViewMode(mode)) {
      this.initializeVoidPickupData(pickupData);
      this.setShipmentInfo();
    } else {
      const initialSelectedPickup = this.resolveInitialSelectedPickupData(pickupData);
      const initialPickupDate = isEmbargoPickupMode(mode)
        ? this.resolvePickupDateForRestrictions(initialSelectedPickup)
        : initialSelectedPickup?.pickupDate;
      this.loadPickupMgmntStaticData(initialPickupDate).then(
        ({ terminals, pickupRestrictions, embargoConfig }) => {
        let shipperList = [],
          selectedPickupData,
          selectedDriver = null;
        if (isMergePickupMode(mode)) {
          const firstAssignPickupSelected = getFirstSelectedAssignedDriverPickup(pickupData);
          selectedPickupData = this.getMergePickupInitialData(
            firstAssignPickupSelected ?? pickupData[0],
            pickupData
          );
          shipperList = getFormattedShippers(pickupData, selectedPossibleMergePickupId);
          selectedDriver = firstAssignPickupSelected?.driverId;
        } else if (isBulkEditPickupMode(mode)) {
          selectedPickupData = initialSelectedPickup;
          shipperList = [];
          selectedDriver = getFirstSelectedAssignedDriverPickup(pickupData)?.driverId;
        } else {
          selectedPickupData = pickupData;
        }
        let terminalsData = terminals;
        if (isMergePickupMode(mode) || this.isEditMode() || isBulkEditPickupMode(mode)) {
          const pickupTerminalCodes = (
            Array.isArray(pickupData) ? pickupData : [selectedPickupData]
          )
            .map((pickup) => pickup?.terminalCode)
            .filter(Boolean);
          terminalsData = terminals.filter((terminal) => {
            return [
              userData.userProfile.terminal.code,
              ...pickupTerminalCodes,
              ...DispatchStore.movePickupTerminalList
            ].includes(terminal.terminalCode);
          });
        }
        this.initializeCommonPickupMgmntData({
          selectedPickupData,
          shipperList,
          pickupRestrictions,
          embargoConfig,
          terminalsData,
          selectedDriver
        });
        this.setShipmentInfo();
      });
    }
  };

  componentDidMount() {
    const pickupData = this.getFormattedPickupData([]);
    this.setState(
      {
        pickupData
      },
      () => {
        this.initializeAllData(pickupData);
      }
    );
    if (isReadOnlyPickupViewMode(this.props.mode) && !isBulkVoidPickupMode(this.props.mode)) {
      if (this.props.mode === PICKUP_MANAGEMENT_MODES.NO_FREIGHT_PICKUP) {
        Events.on(DISPATCH.NoFreightForUnassignedPickup, this.checkReadOnlyPickupViewStatus);
      } else {
        Events.on(DISPATCH.VoidAndUnvoidPickup, this.checkReadOnlyPickupViewStatus);
      }
    }
    if (isMergePickupMode(this.props.mode)) {
      Events.on(DISPATCH.MergePickups, this.checkMergePickupStatus);
    }

    RMAXLogger.info('Pickup_Management', {
      action: 'Viewed'
    });
  }

  componentWillUnmount() {
    this.isUnmounted = true;
    Events.removeListener(DISPATCH.VoidAndUnvoidPickup, this.checkReadOnlyPickupViewStatus);
    Events.removeListener(DISPATCH.MergePickups, this.checkMergePickupStatus);
    Events.removeListener(
      DISPATCH.NoFreightForUnassignedPickup,
      this.checkReadOnlyPickupViewStatus
    );

    // Clear timer if exists
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }

    // Clear instance properties to prevent memory leaks
    this.pickupRestrictionsData = null;
    this.pickupRestrictedTerminals = null;
    this.shipmentInfo = null;
  }

  loadPickupMgmntStaticData = (pickupDate) => {
    const { DispatchStore, userData } = this.props;
    const terminalCode = userData.userProfile.terminal.code;
    if (
      DispatchStore.terminals.length &&
      isPickupRestrictionsCacheValid({
        cached: DispatchStore.pickupRestrictions,
        terminalCode,
        pickupDate
      })
    ) {
      return Promise.resolve({
        terminals: DispatchStore.terminals.slice(),
        pickupRestrictions: normalizePickupRestrictionsData(
          DispatchStore.pickupRestrictions.data
        ),
        embargoConfig: DispatchStore.pickupRestrictions.embargoConfig ?? EMPTY_EMBARGO_CONFIG
      });
    }
    return fetchTerminalAndRestrictionsData(terminalCode, pickupDate).then(
      ([terminalListRes, pickupRestrictionsRes]) => {
        const parsed = parsePickupRestrictionsResponse(pickupRestrictionsRes.data);
        DispatchStore.setTerminals(terminalListRes.data);
        DispatchStore.setPickupRestrictions({
          data: parsed.restrictions,
          embargoConfig: parsed.embargoConfig,
          terminalCode,
          embargoPickupDate: pickupDate
        });
        return {
          terminals: terminalListRes.data ?? [],
          pickupRestrictions: parsed.restrictions,
          embargoConfig: parsed.embargoConfig
        };
      }
    );
  };

  initializeVoidPickupData = (pickupData) => {
    const { userData, mode } = this.props;
    const isBulkVoid = isBulkVoidPickupMode(mode);
    const representativePickup = isBulkVoid ? getBulkEditInitialData(pickupData) : pickupData;
    this.setState({
      pickupInfo: getDefaultPickupManagementInfo(
        representativePickup,
        userData.userProfile.terminal.offset
      ),
      selectedTerminal: userData.userProfile.terminal.code,
      selectedTerminalOffset: userData.userProfile.terminal.offset
    });
    this.updateIsMiscShipper(
      representativePickup?.shipperAccountNumber,
      representativePickup?.isMiscellaneousShipper
    );
  };

  initializeCommonPickupMgmntData = ({
    selectedPickupData,
    shipperList,
    pickupRestrictions,
    embargoConfig,
    terminalsData,
    selectedDriver
  }) => {
    const { terminal: userTerminal } = this.props.userData.userProfile;
    const terminals = getFormattedTerminals(terminalsData);
    const preferredTerminalCode = selectedPickupData?.terminalCode ?? userTerminal.code;
    const selectedTerminal = resolveSelectedTerminal({
      preferredTerminalCode,
      userTerminal,
      terminals,
    });
    this.pickupRestrictionsData = normalizePickupRestrictionsData(pickupRestrictions);
    this.pickupRestrictedTerminals = this.pickupRestrictionsData.map(
      (eachObj) => eachObj.terminalCode
    );
    this.setState({
      terminals,
      pickupInfo: getDefaultPickupManagementInfo(selectedPickupData, selectedTerminal.offset),
      selectedTerminal: selectedTerminal.value,
      selectedTerminalOffset: selectedTerminal.offset,
      shipperList,
      embargoConfig: embargoConfig ?? EMPTY_EMBARGO_CONFIG,
      selectedShipper: getShipperByPickupId(shipperList, selectedPickupData?.pickupId),
      selectedDriver
    });
    this.updateIsMiscShipper(
      selectedPickupData?.shipperAccountNumber,
      selectedPickupData?.isMiscellaneousShipper
    );
  };

  getMergePickupInitialData = (selectedPickup = {}, selectedPickupsList = []) => {
    const combinedSpecialInstructions = getCombinedSpecialInstructions(
      selectedPickupsList.map((pickup) => pickup.specialInstructions)
    );
    return {
      ...selectedPickup,
      ...getLatestReadyCloseTime(selectedPickupsList),
      specialInstructions: combinedSpecialInstructions,
      shipments: selectedPickupsList.map((pickup) => pickup.shipments).flat(),
      isLiftGate: selectedPickupsList.some((pickup) => pickup.isLiftGate)
    };
  };

  getTerminalInputRef = (terminalRef) => {
    this.terminalRef = terminalRef;
  };

  getInitialPickupZipCodes = () => {
    return (
      this.state.pickupData?.shipments
        ?.map((shipment) => shipment.consigneeZip ?? '')
        .filter(Boolean) ?? []
    );
  };

  updateIsMiscShipper = (shipperAccountNumber, isMiscellaneousShipper) => {
    this.isMiscellaneousAccountCode = !Boolean(shipperAccountNumber) || isMiscellaneousShipper;
  };

  checkReadOnlyPickupViewStatus = (data) => {
    if (!this.state.isLoading) {
      // checks if we had submitted data & waiting for from signalR
      return;
    }
    const { success, message, pickupId } = data;
    if (this.state.pickupData.pickupId.toUpperCase() !== pickupId?.toUpperCase()) {
      return;
    }
    let actionType = 'Void';
    if (this.props.mode === PICKUP_MANAGEMENT_MODES.UNVOID_PICKUP) {
      actionType = 'Unvoid';
    } else if (this.props.mode === PICKUP_MANAGEMENT_MODES.NO_FREIGHT_PICKUP) {
      actionType = 'No Freight';
    }
    if (success) {
      this.props.enqueueSnackbar(`${actionType} Pickup Successful.`, {
        variant: 'success'
      });
      this.props.handleClose();
    } else {
      this.props.enqueueSnackbar(`${actionType} Pickup Failed`, {
        variant: 'error'
      });
      this.setState((prevState) => ({
        ...prevState,
        isLoading: false,
        error: message.error
      }));
    }
    clearTimeout(this.timer);
  };

  checkMergePickupStatus = (data) => {
    if (!this.state.isLoading) {
      // checks if we had submitted data & waiting for response
      return;
    }
    const { success } = data;
    const currentPickupIds = this.state.pickupData.map((p) => p.pickupId.toUpperCase());
    const eventPickupIds = data.mergedPickupIds.map((id) => id.toUpperCase());

    // if current merge pickupIds contain atleast 1 pickupId not present in merge pickupId then we can retain the popup
    if (!currentPickupIds.filter((pickupId) => eventPickupIds.includes(pickupId)).length) {
      return;
    }
    const { successMsg, errorMsg } = getSavePickupMessage(this.props.mode);
    if (success) {
      this.props.enqueueSnackbar(successMsg, {
        variant: 'success'
      });

      // Deselecting all the pickups in the grid
      this.props.resetGridSelections();

      this.props.handleClose();
    } else {
      this.props.enqueueSnackbar(errorMsg, {
        variant: 'error'
      });
      this.setState({
        isLoading: false
      });
    }
    clearTimeout(this.timer);
  };

  handleTerminalChange = (selectedTerminal) => {
    const selectedTerminalValue = selectedTerminal ? selectedTerminal.value : null;
    this.setState({
      selectedTerminal: selectedTerminalValue,
      selectedTerminalOffset: selectedTerminal ? selectedTerminal.offset : null,
      selectedTerminalError: getTerminalFieldError(selectedTerminalValue),
      searchFieldError: getSearchFieldError(selectedTerminalValue)
    });
  };

  updateFormData = (name, formData, formErrorData) => {
    this.setState(
      (prevState) => ({
        pickupInfo: {
          ...prevState.pickupInfo,
          [name]: formData
        },
        pickupErrorInfo: {
          ...prevState.pickupErrorInfo,
          ...(formErrorData !== undefined ? { [name]: formErrorData } : {})
        }
      }),
      () => {
        if (
          name === 'pickupDateTimeInfo' &&
          (this.isEditMode() || isBulkEditPickupMode(this.props.mode))
        ) {
          this.setState({
            isDateTimeUpdated: checkIsDateTimeUpdated(
              this.state.pickupData,
              this.state.pickupInfo.pickupDateTimeInfo
            )
          });
        }
      }
    );
  };

  isEditMode = () => {
    return this.props.mode === PICKUP_MANAGEMENT_MODES.EDIT_PICKUP;
  };

  onGridReady = (gridApi) => {
    this.gridApi = gridApi;
  };

  isPickupDataValid = () => {
    const { pickupDateTimeInfo } = this.state.pickupInfo;
    const pickupDateTimeErrorInfo = getPickupDateTimeErrorInfo({
      pickupDateTimeInfo,
      readyTime: pickupDateTimeInfo.readyTime,
      terminalOffset: this.state.selectedTerminalOffset,
      mode: this.props.mode
    });
    this.setState((prevState) => ({
      pickupErrorInfo: {
        ...prevState.pickupErrorInfo,
        pickupDateTimeInfo: pickupDateTimeErrorInfo
      }
    }));
    const pickupError = Object.values({
      ...pickupDateTimeErrorInfo
    }).filter((value) => value).length;
    return Boolean(!pickupError);
  };

  isShipperDataValid = () => {
    if (this.isDisabledEditShipper()) {
      return true;
    }
    const { shipperInfo, pickupDateTimeInfo } = this.state.pickupInfo;
    const shipperErrorInfo = getShipperErrorInfo(shipperInfo, pickupDateTimeInfo.readyTime);
    this.setState((prevState) => ({
      pickupErrorInfo: {
        ...prevState.pickupErrorInfo,
        shipperInfo: shipperErrorInfo
      }
    }));
    const shipperError = Object.values({
      ...shipperErrorInfo
    }).filter((value) => value).length;
    return Boolean(!shipperError);
  };

  isShipmentDataValid = () => {
    const { shipmentInfo } = this.state.pickupInfo;
    const shipmentErrorInfoList = getShipmentErrorInfo(shipmentInfo, this.props.mode);
    this.setState((prevState) => ({
      pickupErrorInfo: {
        ...prevState.pickupErrorInfo,
        shipmentInfo: shipmentErrorInfoList
      }
    }));
    const shipmentError = shipmentErrorInfoList.some((errorInfo) =>
      checkAtLeastOneShipmentInvalid(errorInfo)
    );
    if (shipmentError) {
      this.gridApi.isDataUpdatedOnGrid = true;
      this.gridApi.refreshCells();
    }
    return Boolean(!shipmentError);
  };

  isEditReasonDataValid = () => {
    const { editCodeList = [] } = this.props.DispatchStore.staticClientData?.clientCodes ?? {};
    const { editReasonInfo } = this.state.pickupInfo;
    const editReasonErrorInfo = getEditReasonErrorInfo(
      editReasonInfo,
      this.state.isDateTimeUpdated,
      editCodeList
    );
    this.setState((prevState) => ({
      pickupErrorInfo: {
        ...prevState.pickupErrorInfo,
        editReasonInfo: editReasonErrorInfo
      }
    }));
    const editReasonError = Object.values({
      ...editReasonErrorInfo
    }).filter((value) => value).length;
    return Boolean(!editReasonError);
  };

  isRequestorDataValid = () => {
    const { requestorInfo } = this.state.pickupInfo;
    const requestorErrorInfo = getRequestorErrorInfo(requestorInfo);
    this.setState((prevState) => ({
      pickupErrorInfo: {
        ...prevState.pickupErrorInfo,
        requestorInfo: requestorErrorInfo
      }
    }));
    const requestorError = Object.values(requestorErrorInfo).filter(Boolean).length;
    return Boolean(!requestorError);
  };

  isZipCodeInPickupRestrictionZipList = (zipCode, terminalCode) => {
    return (
      this.pickupRestrictionsData
        .find((zipObj) => zipObj.terminalCode === terminalCode)
        ?.zips.includes(zipCode) ?? false
    );
  };

  isShipperRestrictedZipCode = () => {
    return this.isZipCodeInPickupRestrictionZipList(
      this.state.pickupInfo.shipperInfo.shipperZip,
      this.state.selectedTerminal
    );
  };

  isTerminalInPickupRestrictedList = (terminalCode) => {
    return this.pickupRestrictedTerminals.includes(terminalCode);
  };

  getRestrictedTerminalForShipper = () => {
    return this.isTerminalInPickupRestrictedList(this.state.selectedTerminal)
      ? this.state.selectedTerminal
      : '';
  };

  getRestrictedTerminalsForShipment = () => {
    const restrictedDestinationTerminalList = [];
    const initialShipmentZipcodes = this.getInitialPickupZipCodes();
    this.state.pickupInfo.shipmentInfo.forEach((shipment) => {
      if (
        !initialShipmentZipcodes.includes(shipment.destinationZip) && // if shipment zipcodes do not belong to zipcodes used while creating the pickup
        this.isZipCodeInPickupRestrictionZipList(
          shipment.destinationZip,
          shipment.destinationTerminal
        )
      ) {
        restrictedDestinationTerminalList.push(shipment.destinationTerminal);
      }
    });
    return [...new Set(restrictedDestinationTerminalList)];
  };

  validateShipperWarning = () => {
    const matchedRestrictedTerminal = this.getRestrictedTerminalForShipper();
    if (
      matchedRestrictedTerminal &&
      this.isMiscellaneousAccountCode &&
      this.isShipperRestrictedZipCode()
    ) {
      return {
        hasWarning: true,
        label: `${matchedRestrictedTerminal} ${WARNING_DETAILS.SHIPPER_LABEL}`,
        description: WARNING_DETAILS.SHIPPER_DESCRIPTION
      };
    }
    return { hasWarning: false };
  };

  validateShipmentWarning = () => {
    const matchedRestrictedZipCodeTerminals = this.getRestrictedTerminalsForShipment();
    if (matchedRestrictedZipCodeTerminals.length > 0) {
      return {
        hasWarning: true,
        label: `${matchedRestrictedZipCodeTerminals.join(', ')} ${
          WARNING_DETAILS.DESTINATION_LABEL
        }`,
        description: WARNING_DETAILS.DESTINATION_DESCRIPTION
      };
    }
    return { hasWarning: false };
  };

  setWarningDetails = (warningDetails) => {
    const { label, description, hasWarning } = warningDetails;
    this.warning = {
      label,
      description
    };
    this.setState({ hasWarning });
  };

  pickupRestrictionsValidation = () => {
    const shipperWarningDetails = this.validateShipperWarning();
    if (shipperWarningDetails.hasWarning) {
      this.setWarningDetails(shipperWarningDetails);
      return;
    }
    const shipmentWarningDetails = this.validateShipmentWarning();
    if (shipmentWarningDetails.hasWarning) {
      this.setWarningDetails(shipmentWarningDetails);
      return;
    }
    this.setWarningDetails({
      hasWarning: false,
      label: '',
      description: ''
    });
  };

  shouldRunEmbargoValidation = () => isEmbargoPickupMode(this.props.mode);

  getEmbargoMode = () =>
    this.props.mode === PICKUP_MANAGEMENT_MODES.CREATE_PICKUP
      ? EMBARGO_MODES.CREATE
      : EMBARGO_MODES.EDIT;

  getEmbargoPickupDateFromState = (state) => {
    const pickupDateTimeInfo = state.pickupInfo?.pickupDateTimeInfo;
    if (!pickupDateTimeInfo?.pickupDate) {
      return undefined;
    }
    return getPickupDateTime(pickupDateTimeInfo).pickupDate;
  };

  resolvePickupDateForRestrictions = (pickupData) => {
    const terminalOffset = this.props.userData.userProfile.terminal.offset;
    return getPickupDateTime(getDefaultPickupDateTimeInfo(pickupData, terminalOffset)).pickupDate;
  };

  getEmbargoPickupDate = () => this.getEmbargoPickupDateFromState(this.state);

  applyPickupRestrictionsAndEmbargo = (restrictions, embargoConfig) => {
    this.pickupRestrictionsData = normalizePickupRestrictionsData(restrictions);
    this.pickupRestrictedTerminals = this.pickupRestrictionsData.map((row) => row.terminalCode);
    this.setState({ embargoConfig }, () => {
      this.pickupRestrictionsValidation();
      this.runEmbargoValidation();
    });
  };

  loadPickupRestrictionsAndEmbargo = (terminalCode, pickupDate) => {
    if (!this.shouldRunEmbargoValidation() || !terminalCode) {
      return Promise.resolve(EMPTY_EMBARGO_CONFIG);
    }
    const resolvedPickupDate = pickupDate ?? this.getEmbargoPickupDate();
    const { pickupRestrictions } = this.props.DispatchStore;
    if (
      isPickupRestrictionsCacheValid({
        cached: pickupRestrictions,
        terminalCode,
        pickupDate: resolvedPickupDate
      })
    ) {
      const cachedEmbargoConfig = pickupRestrictions.embargoConfig ?? EMPTY_EMBARGO_CONFIG;
      this.applyPickupRestrictionsAndEmbargo(pickupRestrictions.data, cachedEmbargoConfig);
      return Promise.resolve(cachedEmbargoConfig);
    }
    // Ignore responses from an older in-flight fetch when pickup date changes quickly.
    const requestId = ++this.embargoRulesRequestId;
    return fetchPickupRestrictionsWithEmbargo(terminalCode, resolvedPickupDate).then(
      ({ restrictions, embargoConfig }) => {
        if (requestId !== this.embargoRulesRequestId) {
          return embargoConfig;
        }
        this.props.DispatchStore.setPickupRestrictions({
          data: restrictions,
          embargoConfig,
          terminalCode,
          embargoPickupDate: resolvedPickupDate
        });
        this.applyPickupRestrictionsAndEmbargo(restrictions, embargoConfig);
        return embargoConfig;
      }
    );
  };

  runEmbargoValidation = () => {
    if (!this.shouldRunEmbargoValidation()) {
      if (
        this.state.embargoShipmentViolations.length ||
        this.state.embargoShipmentWarnings.length
      ) {
        this.setState({
          embargoShipmentViolations: [],
          embargoShipmentWarnings: []
        });
      }
      return;
    }
    const { pickupInfo, embargoConfig } = this.state;
    const context = buildEmbargoFormContext({
      mode: this.getEmbargoMode(),
      shipments: pickupInfo?.shipmentInfo
    });
    const result = validateEmbargo({ context, config: embargoConfig });
    this.setState({
      embargoShipmentViolations: result.shipmentViolations,
      embargoShipmentWarnings: result.shipmentWarnings
    });
  };

  handleSubmit = () => {
    const {
      pickupInfo,
      selectedTerminal,
      isDateTimeUpdated,
      hasWarning,
      overrideWarning,
      selectedDriver,
      pickupErrorInfo,
      isExhibitPickupInMergeMode
    } = this.state;
    const { pickupData: currentPickupData } = this.state;
    const isBulkEdit = isBulkEditPickupMode(this.props.mode);
    const isBulkMode = isBulkPickupMode(this.props.mode);
    const { pickupId, pickupNumber } =
      (Array.isArray(currentPickupData) ? currentPickupData[0] : currentPickupData) ?? {};
    const isShipperDataValid = isBulkMode ? true : this.isShipperDataValid();
    const isShipmentDataValid = this.isShipmentDataValid();
    const isPickupDataValid = this.isPickupDataValid();
    const isEditReasonDataValid = isDateTimeUpdated ? this.isEditReasonDataValid() : true;
    const shouldValidateRequestor =
      this.enableRequestorInfo && isCreateOrEditPickupMode(this.props.mode);
    const isRequestorValid =
      shouldValidateRequestor ? this.isRequestorDataValid() : true;
    if (
      isShipperDataValid &&
      isShipmentDataValid &&
      isPickupDataValid &&
      isEditReasonDataValid &&
      isRequestorValid &&
      selectedTerminal &&
      !pickupErrorInfo.swapAndDrop &&
      !(hasWarning && !overrideWarning) && //processing shipment will not be allowed if there is warning and not overridden
      !isEmbargoBlockingConfirm({
        shipmentViolations: this.state.embargoShipmentViolations,
        backendSaveError: this.state.embargoBackendSaveError
      })
    ) {
      const selectedPickups =
        isMergePickupMode(this.props.mode) || isBulkEdit ? this.state.pickupData : null;

      const requestParams = PICKUP_MANAGEMENT_CONFIG[this.props.mode].getRequestParams({
        pickupData: {
          pickupInfo: pickupInfo,
          pickupTerminal: selectedTerminal,
          userProfile: this.props.userData.userProfile,
          pickupId,
          pickupNumber,
          isDateTimeUpdated
        },
        selectedPickups,
        selectedDriver,
        isExhibitPickupInMergeMode,
        enableRequestorInfo: this.enableRequestorInfo,
        originalShipments: this.originalBulkShipments
      });
      const apiName = PICKUP_MANAGEMENT_CONFIG[this.props.mode].apiName;
      if (isMergePickupMode(this.props.mode)) {
        RMAXLogger.info('Merge Pickup Logs', {
          pickupIds: this.props.pickupData.map((p) => p.pickupId),
          terminalCode: this.props.userData.userProfile.terminal.code,
          shipmentCount: pickupInfo?.shipmentInfo?.length ?? 0,
          isToBeReviewed: this.props.pickupData.map((p) => ({
            pickupId: p.pickupId,
            isToBeReviewed: p.isToBeReviewed
          }))
        });
        this.mergePickups(apiName, requestParams);
      } else if (isBulkEdit) {
        RMAXLogger.info('Bulk Edit Pickup Logs', {
          groupId: requestParams.groupId,
          terminalCode: this.props.userData.userProfile.terminal.code,
          removedShipmentCount: requestParams.removedShipments?.length ?? 0
        });
        this.savePickupData(apiName, requestParams);
      } else {
        this.savePickupData(apiName, requestParams);
      }
    } else {
      this.setState(
        {
          error: null
        },
        () => setTimeout(this.focusOnFirstInputWithError)
      );
    }
  };

  focusOnFirstInputWithError = () => {
    const {
      selectedTerminalError,
      pickupErrorInfo: {
        shipperInfo,
        pickupDateTimeInfo,
        editReasonInfo,
        requestorInfo,
        swapAndDrop
      }
    } = this.state;
    if (selectedTerminalError) {
      return this.terminalRef?.current?.focus();
    }
    const errorInfo = {
      ...shipperInfo,
      ...pickupDateTimeInfo,
      ...editReasonInfo,
      ...(requestorInfo || {}),
      swapAndDrop
    };
    const fieldToFocus = this.getFirstInputWithError(ORDERERD_FIELD_LIST, errorInfo);
    if (['editReasonCode', 'swapAndDrop'].includes(fieldToFocus)) {
      return document.getElementById(fieldToFocus)?.scrollIntoView();
    }
    this.focusOnFieldById(fieldToFocus);
  };

  getFirstInputWithError = (orderedFieldList, errorInfo) => {
    return orderedFieldList.find((field) => errorInfo[field]);
  };

  focusOnFieldById = (fieldId) => {
    document.getElementById(fieldId)?.focus();
  };

  isShipmentsModified = (requestParams) => {
    const requestParamsShipments = cloneDeep(requestParams.shipmentData).map((shipment) => {
      delete shipment.sequenceNumber;
      return shipment;
    });
    return !isEqual(this.shipmentInfo, requestParamsShipments);
  };

  savePickupData = (apiName, requestParams) => {
    if (this.isEditMode() || isBulkEditPickupMode(this.props.mode)) {
      const areShipmentsModified = this.isShipmentsModified(requestParams);
      requestParams = { ...requestParams, areShipmentsModified };
      if (this.isEditMode() && this.props.pickupData?.isToBeReviewed) {
        RMAXLogger.info('Edit To Be Reviewed Pickup Data', {
          pickupId: this.props.pickupData.pickupId,
          isToBeReviewed: this.props.pickupData.isToBeReviewed
        });
      }
    }
    this.setState({
      isLoading: true,
      error: null,
      embargoBackendSaveError: null
    });
    const { successMsg, errorMsg } = getSavePickupMessage(this.props.mode);
    postData(apiName, sanitizeObject(requestParams)).then(
      (response) => {
        if (response && Math.trunc(response.status / 100) === 2) {
          this.props.enqueueSnackbar(successMsg, {
            variant: 'success'
          });
          this.props.handleClose();

          this.setState({
            isLoading: false
          });
        } else {
          this.handleSavePickupDataError({
            errorMsg,
            error:
              response?.response?.data?.error?.message ||
              response?.response?.data?.error?.message?.error?.error?.message,
            responseData: response?.response?.data,
            statusCode: response.status
          });
        }
      },
      () => {
        this.handleSavePickupDataError();
      }
    );
  };

  handleSavePickupDataError = ({
    error = null,
    errorMsg = '',
    responseData = null,
    statusCode
  } = {}) => {
    const { embargoBackendSaveError, shouldSuppressSnackbar } =
      resolvePickupSaveFailure({
        responseData,
        statusCode,
        embargoMode: this.getEmbargoMode()
      });
    this.setState({
      isLoading: false,
      embargoBackendSaveError,
      error: isObject(error) ? JSON.stringify(error) : error // Stringify the error if it's an object, otherwise use it as is
    });
    if (shouldSuppressSnackbar) {
      return;
    }
    this.props.enqueueSnackbar(errorMsg, {
      variant: 'error'
    });
  };

  updateSpecialInstructions = ({ specialInstructions, pickupDate, pickupWindow }) => {
    const shipperDayOfWeekComments = getShipperPickupWindow(
      new Date(pickupDate),
      pickupWindow
    )?.additionalComment;
    const combinedSpecialInstructions = [specialInstructions, shipperDayOfWeekComments];
    this.setState((prevState) => ({
      pickupInfo: {
        ...prevState.pickupInfo,
        specialInstructions: getCombinedSpecialInstructions(combinedSpecialInstructions)
      }
    }));
  };

  updateSelectedShipperDataOnSearch = ({
    specialInstructions,
    shipperInfo,
    pickupDateTimeInfo,
    isMiscellaneousShipper,
    isShipperSearched,
    isLiftGate
  }) => {
    if (isMergePickupMode(this.props.mode) && !isShipperSearched) {
      this.handleShipperSelection(this.state.selectedShipper); //  if Searched Shipper is cleared select previously selectd shipper in radio selections in case of merge pickup flow.
      this.setState({ isShipperSearched });
      return;
    }
    const shipperErrorInfo = getShipperErrorInfo(shipperInfo, pickupDateTimeInfo.readyTime);
    const pickupDateTimeErrorInfo = getPickupDateTimeErrorInfo({
      pickupDateTimeInfo,
      readyTime: pickupDateTimeInfo.readyTime,
      terminalOffset: this.state.selectedTerminalOffset
    });
    this.updateIsMiscShipper(shipperInfo.shipperAccountNumber, isMiscellaneousShipper);
    this.setState(
      (prevState) => ({
        pickupInfo: {
          ...prevState.pickupInfo,
          pickupDateTimeInfo,
          shipperInfo,
          isSwapPickup: false,
          isDockDropPickup: false,
          isExhibitPickup: false,
          isLiftGate
        },
        pickupErrorInfo: {
          ...prevState.pickupErrorInfo,
          shipperInfo: shipperErrorInfo,
          pickupDateTimeInfo: pickupDateTimeErrorInfo
        },
        isShipperSearched
      }),
      () =>
        this.updateSpecialInstructions({
          specialInstructions,
          pickupDate: pickupDateTimeInfo.pickupDate,
          pickupWindow: shipperInfo.pickupWindow
        })
    );
    this.updateIsMiscShipper(shipperInfo.shipperAccountNumber, isMiscellaneousShipper);
  };

  updateToggleError = ({ isSwapPickup, isDockDropPickup }) => {
    this.setState((prevState) => ({
      pickupErrorInfo: {
        ...prevState.pickupErrorInfo,
        swapAndDrop: validateToggle({
          isSwapPickup,
          isDockDropPickup
        })
      }
    }));
  };

  handlePickupTypeToggle = (field) => (value) => {
    if (field === 'isExhibitPickupInMergeMode') {
      this.setState({
        [field]: value
      });
      return;
    }
    this.updateFormData(field, value, this.state.pickupErrorInfo);
    const { isSwapPickup, isDockDropPickup } = this.state.pickupInfo;
    this.updateToggleError({
      isDockDropPickup,
      isSwapPickup,
      [field]: value
    });
  };

  handleKeyDown = (event, callback) => {
    if (event?.keyCode === 37) {
      // keyCode: 37, leftArrow Key pressed (disable switch). keyCode: 39, rightArrow Key pressed (enable switch)
      callback(false);
    } else if (event?.keyCode === 39) {
      callback(true);
    }
  };

  handleKeyDownPickTypeToggle = (event) => {
    this.handleKeyDown(event, this.handlePickupTypeToggle);
  };

  handleNoFreightPickupSubmit = () => {
    const {
      noFreightPickup,
      noFreightPickup: { errorInfo }
    } = this.state;
    const { pickupId } = this.state.pickupData;
    const newErrorInfo = getNoFreightErrorInfo({
      errorInfo,
      noFreightPickupData: noFreightPickup,
      shouldEnforceNoFreightReasonCode: this.shouldEnforceNoFreightReasonCode
    });
    this.setState((prevState) => ({
      ...prevState,
      noFreightPickup: {
        ...prevState.noFreightPickup,
        errorInfo: newErrorInfo
      }
    }));
    const error = Object.values(newErrorInfo).filter((value) => value).length;
    if (error) {
      const fieldToFocus = this.getFirstInputWithError(ORDERERD_FIELD_LIST, newErrorInfo);
      return this.focusOnFieldById(fieldToFocus);
    }
    if (!error) {
      const { contactName, callTime, comments, noFreightCode } = noFreightPickup;
      const noFreightPickupData = {
        pickupId,
        terminalCode: this.props.userData.userProfile.terminal.code,
        contactName,
        callTime: convertDateTimeToTimeString(callTime),
        comments,
        ...(this.enableNoFreightCode && { noFreightCode })
      };
      this.setState(
        (prevState) => ({
          ...prevState,
          isLoading: true,
          error: null
        }),
        this.onPickupManagementProgressTimeOut
      );
      RMAXLogger.info('No_Freight_Pickup', {
        action: 'No_Freight_Pickup Clicked',
        pickupId,
        isToBeReviewed: this.props.pickupData.isToBeReviewed
      });
      this.submitData('NoFreightPickup', noFreightPickupData);
    }
  };

  handleVoidPickupSubmit = () => {
    const {
      voidPickup,
      voidPickup: { errorInfo }
    } = this.state;
    const { pickupId } = this.state.pickupData;
    const newErrorInfo = getErrorInfo(errorInfo, voidPickup);
    this.setState((prevState) => ({
      ...prevState,
      voidPickup: {
        ...prevState.voidPickup,
        errorInfo: newErrorInfo
      }
    }));
    const error = Object.values(newErrorInfo).filter((value) => value).length;
    if (error) {
      return this.focusOnFieldById('comment');
    }
    if (!error) {
      const { voidReason, comment } = voidPickup;
      const voidData = {
        pickupId,
        terminalCode: this.props.userData.userProfile.terminal.code,
        voidReason,
        comment
      };
      this.setState(
        (prevState) => ({
          ...prevState,
          isLoading: true,
          error: null
        }),
        this.onPickupManagementProgressTimeOut
      );
      RMAXLogger.info('Void_Pickup', {
        action: 'Void_Pickup Clicked',
        pickupId,
        isToBeReviewed: this.props.pickupData.isToBeReviewed
      });
      this.submitData('VoidPickup', voidData);
    }
  };

  handleBulkVoidPickupSubmit = () => {
    const {
      voidPickup,
      voidPickup: { errorInfo }
    } = this.state;
    const pickupData = this.state.pickupData;
    const groupId = getBulkGroupId(pickupData);
    const newErrorInfo = getErrorInfo(errorInfo, voidPickup);
    this.setState((prevState) => ({
      ...prevState,
      voidPickup: {
        ...prevState.voidPickup,
        errorInfo: newErrorInfo
      }
    }));
    const error = Object.values(newErrorInfo).filter((value) => value).length;
    if (error) {
      return this.focusOnFieldById('comment');
    }
    if (!groupId) {
      RMAXLogger.info('Bulk_Void_Pickup', {
        action: 'Bulk_Void_Pickup_Aborted_Missing_GroupId',
        pickupIds: Array.isArray(pickupData)
          ? pickupData.map((p) => p?.pickupId).filter(Boolean)
          : null
      });
      this.props.enqueueSnackbar('Void Group Failed', { variant: 'error' });
      return;
    }
    const { voidReason, comment } = voidPickup;
    const voidData = {
      groupId,
      terminalCode: this.props.userData.userProfile.terminal.code,
      voidReason,
      comment
    };
    this.setState((prevState) => ({
      ...prevState,
      isLoading: true,
      error: null
    }));
    RMAXLogger.info('Bulk_Void_Pickup', {
      action: 'Bulk_Void_Pickup Clicked',
      groupId
    });
    const { successMsg, errorMsg } = getSavePickupMessage(this.props.mode);
    postData('BulkVoid', sanitizeObject(voidData)).then(
      (response) => {
        if (response && Math.trunc(response.status / 100) === 2) {
          this.props.enqueueSnackbar(successMsg, { variant: 'success' });
          if (typeof this.props.resetGridSelections === 'function') {
            this.props.resetGridSelections();
          }
          this.props.handleClose();
          this.setState({ isLoading: false });
        } else {
          this.handleSavePickupDataError({
            errorMsg,
            error:
              response?.response?.data?.error?.message ||
              response?.response?.data?.error?.message?.error?.error?.message,
            statusCode: response?.status
          });
        }
      },
      () => {
        this.handleSavePickupDataError({ errorMsg });
      }
    );
  };

  handleUnvoidPickupSubmit = () => {
    const {
      unvoidPickup,
      unvoidPickup: { errorInfo }
    } = this.state;
    const { pickupId } = this.props.pickupData;
    const newErrorInfo = getErrorInfo(errorInfo, unvoidPickup);
    this.setState((prevState) => ({
      ...prevState,
      unvoidPickup: {
        ...prevState.unvoidPickup,
        errorInfo: newErrorInfo
      }
    }));
    const error = Object.values(newErrorInfo).filter((value) => value).length;
    if (error) {
      return this.focusOnFieldById('comment');
    }
    if (!error) {
      const { comment } = unvoidPickup;
      const unvoidData = {
        pickupId,
        terminalCode: this.props.userData.userProfile.terminal.code,
        comment
      };
      this.setState(
        (prevState) => ({
          ...prevState,
          isLoading: true,
          error: null
        }),
        this.onPickupManagementProgressTimeOut
      );
      RMAXLogger.info('Unvoid_Pickup Clicked', {
        action: 'Unvoid_Pickup',
        pickupId: unvoidData.pickupId,
        isToBeReviewed: this.props.pickupData.isToBeReviewed
      });
      this.submitData('UnvoidPickup', unvoidData);
    }
  };

  mergePickups = (apiName, requestParams) => {
    this.setState(
      {
        isLoading: true,
        error: null,
        embargoBackendSaveError: null
      },
      this.onPickupManagementProgressTimeOut
    );
    const areShipmentsModified = this.isShipmentsModified(requestParams);
    this.submitData(apiName, { ...requestParams, areShipmentsModified });
  };

  submitData = (apiName, requestParams) => {
    postData(apiName, sanitizeObject(requestParams)).then(
      (response) => {
        if (response && Math.trunc(response.status / 100) === 2);
        else {
          const apiErrorMsg =
            response?.response?.data?.error?.message || response?.response?.data?.error?.details;
          this.handleError({
            apiErrorMsg,
            statusCode: response.status,
            responseData: response?.response?.data
          });
        }
      },
      () => {
        this.handleError();
      }
    );
  };

  handleError = ({ apiErrorMsg = null, statusCode, responseData = null } = {}) => {
    clearTimeout(this.timer);
    const shouldResolveEmbargoError = isEmbargoPickupMode(this.props.mode);
    const { embargoBackendSaveError, shouldSuppressSnackbar } = shouldResolveEmbargoError
      ? resolvePickupSaveFailure({
          responseData,
          statusCode,
          embargoMode: this.getEmbargoMode()
        })
      : { embargoBackendSaveError: null, shouldSuppressSnackbar: statusCode === 403 };
    this.setState({
      isLoading: false,
      error: apiErrorMsg,
      ...(shouldResolveEmbargoError ? { embargoBackendSaveError } : {})
    });
    if (shouldSuppressSnackbar) {
      return;
    }
    const { errorMsg } = getSavePickupMessage(this.props.mode);
    this.props.enqueueSnackbar(errorMsg, {
      variant: 'error'
    });
  };

  updateVoidPickup = (voidPickupData) => {
    this.setState({
      voidPickup: voidPickupData
    });
  };

  updateUnvoidPickup = (unvoidPickupData) => {
    this.setState({
      unvoidPickup: unvoidPickupData
    });
  };

  updateNoFreightPickup = (noFreightPickupData) => {
    this.setState({
      noFreightPickup: noFreightPickupData
    });
  };

  getNoFreightCodes = () => {
    if (this.enableNoFreightCode) {
      return (
        this.props.DispatchStore.staticClientData?.clientCodes?.noFreightCode?.map(
          (noFreightCodeItem) => ({
            label: getNoFreightCodeOptionLabel({
              description: noFreightCodeItem.description,
              code: noFreightCodeItem.code,
              enableReturnExceptionReasonLabels: this.enableReturnExceptionReasonLabels
            }),
            value: noFreightCodeItem.code
          })
        ) || []
      );
    }
    return [];
  };

  onPickupManagementProgressTimeOut = () => {
    this.timer = setTimeout(() => {
      this.setState({ isLoading: false });
    }, appConstants.ONE_MINUTE_TIME_OUT);
  };

  onSubmitButtonClicked = () => {
    const { mode } = this.props;
    if (isReadOnlyPickupViewMode(mode)) {
      if (mode === PICKUP_MANAGEMENT_MODES.NO_FREIGHT_PICKUP) {
        return this.handleNoFreightPickupSubmit;
      }
      if (isBulkVoidPickupMode(mode)) {
        return this.handleBulkVoidPickupSubmit;
      }
      return mode === PICKUP_MANAGEMENT_MODES.VOID_PICKUP
        ? this.handleVoidPickupSubmit
        : this.handleUnvoidPickupSubmit;
    } else {
      return this.handleSubmit;
    }
  };

  handleShipperSelection = (selectedShipperData) => {
    const selectedShipper = JSON.parse(selectedShipperData);
    const selectedPickupData = this.state.pickupData.find(
      (pickup) =>
        pickup.rmaxShipperCode === selectedShipper.rmaxShipperCode &&
        pickup.pickupId === selectedShipper.pickupId
    );
    const pickupInfo = getDefaultPickupManagementInfo(
      this.getMergePickupInitialData(selectedPickupData, this.state.pickupData)
    );
    const shipperErrorInfo = getShipperErrorInfo(
      pickupInfo.shipperInfo,
      pickupInfo.pickupDateTimeInfo.readyTime
    );
    const pickupDateTimeErrorInfo = getPickupDateTimeErrorInfo({
      pickupDateTimeInfo: pickupInfo.pickupDateTimeInfo,
      readyTime: pickupInfo.pickupDateTimeInfo.readyTime,
      terminalOffset: this.state.selectedTerminalOffset
    });
    this.setState((prevState) => ({
      pickupInfo,
      selectedShipper: selectedShipperData,
      pickupErrorInfo: {
        ...prevState.pickupErrorInfo,
        shipperInfo: shipperErrorInfo,
        pickupDateTimeInfo: pickupDateTimeErrorInfo
      }
    }), () => {
      this.handleDriverChange({ value: selectedPickupData.driverId });
      this.updateIsMiscShipper(
        selectedPickupData.shipperAccountNumber,
        selectedPickupData.isMiscellaneousShipper
      );
    });
  };

  onToggleWarningOverride = () => {
    this.setState((prevState) => ({
      ...prevState,
      overrideWarning: !prevState.overrideWarning
    }));
  };

  handleDriverChange = (option) => {
    const driverId = option ? option.value : null;
    const routeList = this.props.DispatchStore.currentActiveRoutes.slice();
    const driverRoute = driverId ? routeList.find((route) => route.driverId === driverId) : null;
    this.setState({
      selectedDriver: driverId,
      driverRoute
    });
  };

  isDriverArrivedAtStop = (driverRoute) => {
    return driverRoute?.currentStatus?.status === DRIVER_EVENTS.ArrivedAtStop;
  };

  isDriverArrivedAtMergePickupStop = () => {
    const assignedPickups = this.props.pickupData.filter((pickup) => pickup.driverId);
    if (!assignedPickups.length) {
      return false;
    }
    return assignedPickups.some((pickup) => {
      const driverId = pickup.driverId;
      const { routesList } = this.props.DispatchStore;
      const driverRoute = routesList.find((route) => route.driverId === driverId);
      if (!this.isDriverArrivedAtStop(driverRoute)) {
        return false;
      }
      const arrivedPickupStop = driverRoute.stops
        .filter((stop) => stop.stopType === appConstants.STOP_TYPE.Pickup)
        .find((stop) => stop.stopId === driverRoute.currentStatus.stopId);
      return pickup.pickupId.toUpperCase() === arrivedPickupStop?.pickupId.toUpperCase();
    });
  };

  isDisabledConfirmButton = ({ isMergePickupModeSelected, isDriverArrivedAtMergePickupStop }) => {
    if (this.state.isConfirmButtonDisabled) {
      return true;
    }
    const {
      shipperList,
      hasWarning,
      overrideWarning,
      shipmentGridError,
      embargoShipmentViolations,
      embargoBackendSaveError
    } = this.state;
    return (
      [appConstants.GRID_STATUS.ERROR].includes(shipmentGridError) ||
      (hasWarning && !overrideWarning) ||
      isEmbargoBlockingConfirm({
        shipmentViolations: embargoShipmentViolations,
        backendSaveError: embargoBackendSaveError
      }) ||
      (isMergePickupModeSelected && (shipperList.length < 2 || isDriverArrivedAtMergePickupStop))
    ); /* min 2 shipper required for merge */
  };

  getSelectedPickupsByIds = (duplicatePickupIds) => {
    return duplicatePickupIds
      .map((pickupId) => this.props.DispatchStore.getPickupData(pickupId))
      .filter(Boolean);
  };

  isMergePickupEditingAllowed = () => {
    return this.enablePickupEdit || !this.props.configJSON.enableMergePickup; // added for smt to disable edit shipper info
  };

  isDisabledEditShipper = () => {
    const { configJSON, mode } = this.props;
    const shipperInfo = this.state.pickupInfo?.shipperInfo;
    const isMisc = shipperInfo?.isMiscellaneousShipper;

    // Miscellaneous shippers are always editable
    if (isMisc) return false;

    // In Merge Pickup mode
    if (isMergePickupMode(mode)) {
      if (this.isMergePickupEditingAllowed()) {
        return !configJSON.enablePickupShipperEdit;
      }

      return true; // Default to disabled if editing is not allowed
    }

    // Non-merge mode: use config flag directly
    return !configJSON.enablePickupShipperEdit;
  };

  render() {
    const { handleClose, classes, mode } = this.props;
    const {
      terminals,
      selectedTerminal,
      pickupInfo,
      pickupErrorInfo,
      isDateTimeUpdated,
      error,
      selectedTerminalOffset,
      selectedTerminalError,
      searchFieldError,
      overrideWarning,
      hasWarning,
      shipperList,
      selectedShipper,
      isShipperSearched,
      selectedDriver,
      driverRoute,
      pickupData,
      shipmentGridError,
      embargoShipmentViolations,
      embargoShipmentWarnings,
      embargoBackendSaveError
    } = this.state;
    const isBulkEdit = isBulkEditPickupMode(mode);
    const isBulkVoid = isBulkVoidPickupMode(mode);
    const isBulkMode = isBulkPickupMode(mode);
    const showBillingForm = isPickupManagementBillingMode(mode);
    const disabledRequiredLG =
      [
        PICKUP_MANAGEMENT_MODES.VOID_PICKUP,
        PICKUP_MANAGEMENT_MODES.UNVOID_PICKUP,
        PICKUP_MANAGEMENT_MODES.NO_FREIGHT_PICKUP
      ].includes(mode) || isBulkVoid;
    const showRequestorDetails = shouldShowRequestorInPickupManagement({
      enableRequestorInfo: this.enableRequestorInfo,
      mode
    });
    const isMergePickupModeSelected = isMergePickupMode(mode);
    let [isDriverArrivedAtMergePickupStop, showDriverDetails] = [false, false];
    const isDisabledEditShipper = this.isDisabledEditShipper();
    if (isMergePickupModeSelected) {
      isDriverArrivedAtMergePickupStop = this.isDriverArrivedAtMergePickupStop();
      showDriverDetails = this.isMergePickupEditingAllowed();
    }
    const showEditReasonForm = (this.isEditMode() || isBulkEdit) && isDateTimeUpdated;
    const bulkPickupNumbers = isBulkMode ? getBulkPickupNumbers(pickupData) : [];
    const bulkPickupRowForPickupInfo =
      isBulkMode && Array.isArray(pickupData)
        ? getBulkPickupRowForPickupInfo(pickupData)
        : pickupData;
    const toggleError = pickupErrorInfo.swapAndDrop;
    const { voidCodeList = [], editCodeList = [] } =
      this.props.DispatchStore.staticClientData?.clientCodes ?? {};
    if (!pickupInfo) {
      return (
        <div id="appContainer">
          <AppLoading />
        </div>
      );
    }
    return (
      <div className={classes.dialogMainContainer} id="mainContainer">
        <div className={`${classes.contentContainer} customScroll`}>
          {isEmbargoPickupMode(mode) && (
            <EmbargoPickupManagementBanners
              saveError={embargoBackendSaveError}
              violations={embargoShipmentViolations}
              warnings={embargoShipmentWarnings}
              mode={this.getEmbargoMode()}
            />
          )}
          <Grid container>
            <Grid item xs={4} className={classes.leftPanelContainer}>
              <ShipperInfoForm
                shipperInfo={pickupInfo.shipperInfo}
                shipperErrorInfo={pickupErrorInfo.shipperInfo}
                specialInstructions={pickupInfo.specialInstructions}
                terminals={terminals}
                userProfile={this.props.userData.userProfile}
                selectedTerminal={selectedTerminal}
                selectedTerminalOffset={selectedTerminalOffset}
                handleTerminalChange={this.handleTerminalChange}
                getTerminalRef={this.getTerminalInputRef}
                updateFormData={this.updateFormData}
                updateSelectedShipperDataOnSearch={this.updateSelectedShipperDataOnSearch}
                isShipperSearched={isShipperSearched}
                mode={mode}
                selectedTerminalError={selectedTerminalError}
                searchFieldError={searchFieldError}
                isReadOnly={isReadOnlyPickupViewMode(mode) || this.isReadOnlyPickupMergeMode}
                isDisabledEditShipper={isDisabledEditShipper || isBulkMode}
                pickupId={pickupInfo.pickupId}
                disableSpecialInstructions={this.isReadOnlyPickupMergeMode || isBulkMode}
              />
            </Grid>
            <Grid item xs={8} className={classes.rightPanelContainer}>
              <PickupTypeToggles
                mode={mode}
                pickupInfo={pickupInfo}
                isAssignedPickup={bulkPickupRowForPickupInfo?.driverId}
                toggleError={toggleError}
                handlePickupTypeToggle={this.handlePickupTypeToggle}
                handleKeyDownPickTypeToggle={this.handleKeyDownPickTypeToggle}
                classes={classes}
                isExhibitPickupInMergeMode={this.state.isExhibitPickupInMergeMode}
                isReadOnlyPickupMergeMode={this.isReadOnlyPickupMergeMode || isBulkVoid}
              />

              {shipperList.length > 0 && !isBulkMode && (
                <Grid item xs={12}>
                  <SelectShipperForm
                    shipperList={shipperList}
                    selectedShipper={selectedShipper}
                    handleShipperSelection={this.handleShipperSelection}
                    isShipperSearched={isShipperSearched}
                  />
                </Grid>
              )}

              {showDriverDetails && !isBulkMode && (
                <Grid item xs={12}>
                  <DriverDetails
                    drivers={this.props.DispatchStore.activeDriversList}
                    selectedDriver={selectedDriver}
                    handleDriverChange={this.handleDriverChange}
                    driverRoute={driverRoute}
                    showTrailerScac={this.props.configJSON.showTrailerScac}
                  />
                </Grid>
              )}
              {isBulkMode && (
                <Grid item xs={12}>
                  <SelectedPickupsInfo pickupNumbers={bulkPickupNumbers} mode={mode} />
                </Grid>
              )}
              <Grid item xs={12}>
                <PickupInfo
                  mode={mode}
                  pickupErrorInfo={pickupErrorInfo.pickupDateTimeInfo}
                  pickupInfo={pickupInfo.pickupDateTimeInfo}
                  updateFormData={this.updateFormData}
                  userProfile={this.props.userData.userProfile}
                  selectedTerminalOffset={selectedTerminalOffset}
                  pickupData={bulkPickupRowForPickupInfo}
                  shipperInfo={pickupInfo?.shipperInfo}
                  updateSpecialInstructions={this.updateSpecialInstructions}
                  configJSON={this.props.configJSON}
                  routeMappingData={this.props.DispatchStore.routeMappingData?.slice()}
                  isReadOnlyPickupMergeMode={this.isReadOnlyPickupMergeMode || isBulkVoid}
                />
              </Grid>
              {isCreateOrEditPickupMode(mode) && (
                <Grid item xs={12}>
                  <DuplicatePickupChecker
                    terminalCode={this.props.userData.userProfile.terminal.code}
                    getSelectedPickupsByIds={this.getSelectedPickupsByIds}
                    editPickup={this.props.editPickup}
                    mergePickup={this.props.mergePickup}
                    pickupData={pickupData}
                    mode={mode}
                    enablePickupEdit={this.enablePickupEdit}
                    {...getDuplicatePickupCheckerParams({
                      pickupInfo,
                      selectedTerminal,
                      selectedTerminalError,
                      pickupErrorInfo
                    })}
                  />
                </Grid>
              )}
              <RequiresLG
                handleChange={this.updateFormData}
                isLiftGate={pickupInfo.isLiftGate}
                disabled={disabledRequiredLG || this.isReadOnlyPickupMergeMode}
              />
              <Grid item xs={12}>
                <ShipmentInfoForm
                  shipmentInfo={{
                    shipments: pickupInfo.shipmentInfo,
                    shipmentsErrors: pickupErrorInfo.shipmentInfo
                  }}
                  handleChange={this.updateFormData}
                  title="ShipmentsGrid"
                  onGridReady={this.onGridReady}
                  mode={mode}
                  shipmentGridError={shipmentGridError}
                  getPickupShipments={() => this.getPickupShipments(pickupInfo)}
                  isReadOnlyPickupMergeMode={this.isReadOnlyPickupMergeMode}
                  isBulkEditPickup={isBulkEdit}
                  embargoShipmentViolations={embargoShipmentViolations}
                  embargoShipmentWarnings={embargoShipmentWarnings}
                />
              </Grid>
              {showBillingForm && (
                <Grid item xs={12}>
                  <BillingForm
                    mode={mode}
                    billingInfo={pickupInfo.billingInfo}
                    updateFormData={this.updateFormData}
                  />
                </Grid>
              )}
              {showRequestorDetails && (
                <Grid item xs={12}>
                  <PickupRequestorInfo
                    requestorInfo={pickupInfo.requestorInfo}
                    requestorErrorInfo={pickupErrorInfo.requestorInfo}
                    updateFormData={this.updateFormData}
                    isReadOnly={isReadOnlyPickupViewMode(mode)}
                  />
                </Grid>
              )}
              {showEditReasonForm && (
                <Grid item xs={12}>
                  <EditReasonForm
                    editCodeList={editCodeList}
                    editReasonInfo={pickupInfo.editReasonInfo}
                    editReasonErrorInfo={pickupErrorInfo.editReasonInfo}
                    updateFormData={this.updateFormData}
                    isDateTimeUpdated={isDateTimeUpdated}
                  />
                </Grid>
              )}
              {mode === PICKUP_MANAGEMENT_MODES.NO_FREIGHT_PICKUP && (
                <Grid item xs={12}>
                  <NoFreightInfo
                    noFreightPickupData={this.state.noFreightPickup}
                    updateNoFreightPickup={this.updateNoFreightPickup}
                    noFreightCodes={this.noFreightCodes}
                    showNoFreightCodeDropdown={this.showNoFreightCodeDropdown}
                    shouldEnforceNoFreightReasonCode={this.shouldEnforceNoFreightReasonCode}
                  />
                </Grid>
              )}
              {(mode === PICKUP_MANAGEMENT_MODES.VOID_PICKUP || isBulkVoid) && (
                <Grid item xs={12}>
                  <VoidPickup
                    voidCodeList={voidCodeList}
                    glEventHub={this.props.glEventHub}
                    pickupId={bulkPickupRowForPickupInfo?.pickupId}
                    handleClose={handleClose}
                    updateVoidPickup={this.updateVoidPickup}
                    voidPickupData={this.state.voidPickup}
                  />
                </Grid>
              )}
              {mode === PICKUP_MANAGEMENT_MODES.UNVOID_PICKUP && (
                <Grid item xs={12}>
                  <UnvoidPickup
                    glEventHub={this.props.glEventHub}
                    pickupId={pickupData.pickupId}
                    handleClose={handleClose}
                    updateUnvoidPickup={this.updateUnvoidPickup}
                    unvoidPickupData={this.state.unvoidPickup}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
        </div>
        {error && <ErrorContainer message={error} />}
        <Grid className={classes.actionContainer}>
          <Warning
            mode={mode}
            warning={this.warning ?? {}}
            hasWarning={hasWarning}
            overrideWarning={overrideWarning}
            onToggleWarningOverride={this.onToggleWarningOverride}
          />
          <PanelAction
            handleClose={handleClose}
            confirmButtonText={getConfirmationButtonLabel(mode, selectedDriver)}
            handleSubmit={this.onSubmitButtonClicked()}
            isLoading={this.state.isLoading}
            isDisabled={this.isDisabledConfirmButton({
              isMergePickupModeSelected,
              isDriverArrivedAtMergePickupStop
            })}
            disableMsg={
              isDriverArrivedAtMergePickupStop
                ? FORM_VALIDATION_MSG.MERGE_PICKUP_DRIVER_ARRIVED_SHIPPER_LOC
                : null
            }></PanelAction>
        </Grid>
      </div>
    );
  }
}

export default compose(
  withUserProfile,
  withStyles(styles),
  withSnackbar,
  WithModal,
  withFeatureFlags,
  withAppConfig
)(PickupManagementForm);
